import React from "react";
import { Helmet } from "react-helmet";

function ComputerCenter() {
  return (
		<>
			<Helmet>
				<title>VBU - Computer Center</title>
			</Helmet>
			<div className="PageContainer">
				<div className="Campus">
					<div id="Heading">
						<h1>Computer Center</h1>
					</div>

					<div className="Desc">
						<div className="DescParagraph" style={{ width: '100%' }}>
							<p>
								The State-of-the-Art Computer Center serves as the primary technological nervous system of the MCA Department, explicitly designed to fulfill the advanced computational, programming, and comprehensive research needs of our postgraduate IT students.
								<br />
								<br />
								It is fully equipped with an extensive array of modern, high-end, interconnected desktop workstations featuring the latest microprocessors and abundant memory. The entire center leverages a high-speed fiber-optic Gigabit local area network combined with ubiquitous, robust Wi-Fi connectivity to ensure rapid data transfers and uninterrupted internet access.
								<br />
								<br />
								To support the rigorous MCA curriculum, the Computer Center houses licensed versions of enterprise-grade development software, elite database management systems, and advanced networking simulators. Furthermore, dedicated server nodes strictly facilitate specialized practical labs focused intently on Artificial Intelligence, Cloud Computing, and Big Data Analytics, making the center an unparalleled asset for academic excellence.
							</p>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default ComputerCenter;
